export default __webpack_public_path__ + "static/media/BioApp_Logo_Animated.a9926b99.svg";